import type { IconSvgObject } from './types';

const Chair03Icon: IconSvgObject = [
  ["path", { d: "M7 12H17", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 15H17", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7.5 6L6 22M16.5 6L18 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M6 6H18V5C18 3.34315 16.8487 2 15.4286 2H8.57143C7.15127 2 6 3.34315 6 5V6Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Chair03Icon;
